import CardProductVariantSwatch from "~/js/common/cardProductVariantSwatch";

new CardProductVariantSwatch();
